import React from "react";
import ErrorImage from "../../../../../assets/images/livekasmbg.png";

import { Spinner } from "reactstrap";
class Image extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
      url: this.props.src || ErrorImage,
    };
  }

  onError() {
    this.setState({
      isLoading: false,
      isError: true,
      url: ErrorImage,
    });
  }

  onLoaded() {
    this.setState({ isLoading: false });
  }

  render() {
    const { isLoading, url } = this.state;

    return (
      <div>
        <div
        className="tw-items-center tw-py-8"
        style={{
          width: "100%",
          display: isLoading ? "tw-flex" : "none"
        }}>
          <Spinner
            style={{
              width: "64px",
              height: "64px",
            }}
            color="danger"
          />
        </div>
        <img
          {...this.props}
          onError={() => this.onError()}
          onLoad={() => this.onLoaded()}
          src={url}
          style={{
            display: isLoading ? "none" : "block"
          }}
        />
      </div>
    );
  }
}

export default Image;
